// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM8 5V9H11V11H6.5V15H5V19H10V15H8.5V13H15.5V15H14V19H19V15H17.5V11H13V9H16V5H8Z"}}]};

const ViewOrganizationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-organization-filled',
    ref,
    icon: element,
  },
));

ViewOrganizationFilledIcon.displayName = 'ViewOrganizationFilledIcon';

export default ViewOrganizationFilledIcon;
